module.exports = __webpack_public_path__ + "static/media/footer-graphics.18cf6a65.svg";